module.exports = __webpack_public_path__ + "media/images/workplace/welcome_bg/2-7a80fcc6623fe168b110d200fd842445.jpg";